import { render, staticRenderFns } from "./OperatorServiceStatusSwitch.vue?vue&type=template&id=0a9b97db"
import script from "./OperatorServiceStatusSwitch.vue?vue&type=script&lang=js"
export * from "./OperatorServiceStatusSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports